
export enum JobSerachingType {
    JobState = 1,
    JobVendorState = 2
}